import * as yup from 'yup';

import {REGEX_FOR_INTERNAL_NAME} from 'helpers/validation';

export const validationSchema = () =>
    yup.object({
        formVariable: yup
            .string()
            .required('messages.validation.isRequired')
            .matches(REGEX_FOR_INTERNAL_NAME, 'messages.validation.internalNameValidation'),
    });
